import { forwardRef } from 'react';

import { RowColumn } from '../../Containers';
import { Skeleton } from '../../UI';

import { Input, InputProps } from '../Input';
import { Label } from '../Label';

import { cn } from 'styles';

import { WithLabelCommonProps } from './types';

export type LabeledInputProps = WithLabelCommonProps & InputProps;

export const LabeledInput = forwardRef<HTMLInputElement, LabeledInputProps>(
  (
    {
      containerClassName,
      fullWidth,
      gap = '2',
      orientation = 'vertical',

      label,
      labelClassName,
      labelIcon: LabelIcon,

      loading,
      error,

      ...inputProps
    },
    ref,
  ) => {
    const hasError = !!error;

    return (
      <RowColumn
        orientation={orientation}
        fullWidth={fullWidth}
        className={containerClassName}
        gap={gap}
      >
        {label && (
          <Label className={labelClassName} htmlFor={inputProps.id} icon={LabelIcon}>
            {label}
          </Label>
        )}

        {loading ? (
          <Skeleton height={36} />
        ) : (
          <Input
            autoComplete="off"
            className={cn(inputProps.className, hasError && 'border-destructive')}
            ref={ref}
            {...inputProps}
          />
        )}

        {hasError && typeof error == 'string' && (
          <span className="-mt-1 pl-0.5 text-sm text-destructive animate-in fade-in-0 slide-in-from-top-2">
            {error}
          </span>
        )}
      </RowColumn>
    );
  },
);

LabeledInput.displayName = 'LabeledInput';
